import React, { Component } from 'react';
import _ from 'lodash';
import { MoreVert as MoreVertIcon } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import {
	WithStyles,
	createStyles,
} from '@material-ui/core';
import { MyPATPopMenu, MenuData } from '../../../common';
const styles = createStyles({
	root: {
	}
});
//@ts-ignore
interface MilestoneMoreMenuProps extends WithStyles<typeof styles> {
	classes: any,
	clicked?: Function,
	mileStoneAction:[],
	mileStoneLength:any,
}
interface MilestoneMoreMenuState {
	moreAnchorEl: any
}

class MilestoneMoreMenu extends Component<MilestoneMoreMenuProps, MilestoneMoreMenuState>{
	menuItems: MenuData[] = [
		// {
		// 	type: 'callback',
		// 	id: 2,
		// 	to: "",
		// 	img: "",
		// 	text: "Delete"
		// }	
	];

	constructor(props: MilestoneMoreMenuProps, state: MilestoneMoreMenuState) {
		super(props);

		this.clicked = this.clicked.bind(this);
	}

	clicked(item: any) {
		if (this.props.clicked) {
			this.props.clicked(item.text);
		}
	}
	render() {
		let menuI: MenuData[] = this.menuItems;
		const { mileStoneAction, mileStoneLength } = this.props;

		if(mileStoneLength < 2)
		{
				menuI = [
				{
				type: 'callback',
				id: 3,
				to: "",
				img: "",
				text: "Edit"
				},
				{
					type: 'callback',
					id: 2,
					to: "",
					img: "",
					text: "Delete"
				}
			];
			return (<MyPATPopMenu id="content-more-menu" icon={MoreVertIcon} menuItem={menuI} clicked={this.clicked} />
		);
		}
		// else{
			// menuI = [
			// 	{
			// 	type: 'callback',
			// 	id: 4,
			// 	to: "",
			// 	img: "",
			// 	text: "Combine"
			// 	},
			// 	{
			// 		type: 'callback',
			// 		id: 5,
			// 		to: "",
			// 		img: "",
			// 		text: "Cancel"
			// 	}
			// ];
		// }
		return ("");
	}
}

// @ts-ignore
export default withStyles(styles)(MilestoneMoreMenu);